import {requireFirstPartyApi} from './canonicalOrigin';

const BASE = process.env.REACT_APP_BACKEND_URL;
if (!BASE) throw new Error('Missing backend configuration');
export const REQUEST_HEADERS = {'X-TriageFlow-Request': '1'};
export const apiUrl = (path: string): string => `${BASE}/api${path}`;

export function rawRequest(path: string, options: RequestInit = {}): Promise<Response> {
  requireFirstPartyApi();
  const headers = new Headers(options.headers);
  headers.set('X-TriageFlow-Request', REQUEST_HEADERS['X-TriageFlow-Request']);
  if (!(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  return fetch(apiUrl(path), {...options, headers, credentials: 'include'});
}

interface ErrorPayload {detail?: string | Array<{msg?: string}>}
export function payloadError(payload: unknown, fallback: string): Error {
  if (!payload || typeof payload !== 'object') return new Error(fallback);
  const detail = (payload as ErrorPayload).detail;
  if (typeof detail === 'string') return new Error(detail);
  if (Array.isArray(detail) && detail[0]?.msg) return new Error(detail[0].msg);
  return new Error(fallback);
}

export async function responseError(response: Response, fallback: string): Promise<Error> {
  return payloadError(await response.json().catch(() => null), fallback);
}